import {
  LOAD_DATA
} from './actions'

export default {
  namespaced: false,
  state: {
    name: 'home'
  },
  getters: {},
  mutations: {
    [LOAD_DATA] (state, params) {
      console.log('LOAD_DATA')
    }
  },
  actions: {
    async [LOAD_DATA] ({ commit }, params) {
      commit(LOAD_DATA)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/home/index.js